import { NOTIFICATION_CATEGORY } from "services/notifications/types/enums";

export const switchNavRoute = (
  item: NOTIFICATION_CATEGORY,
  id: string
): string => {
  let path = "";
  switch (item) {
    case NOTIFICATION_CATEGORY.Releases:
      break;

    case NOTIFICATION_CATEGORY.Labels:
      path = `/label/${id}/finances`;
      break;

    case NOTIFICATION_CATEGORY.Contracts:
      path = `/contracts`;
      break;

    case NOTIFICATION_CATEGORY.Youtube:
      path = `/channel/${id}`;
      break;

    case NOTIFICATION_CATEGORY.Settlements:
      path = `/settlement`;
      break;

    case NOTIFICATION_CATEGORY.Statements:
      path = `/statements/${id}`;
      break;

    case NOTIFICATION_CATEGORY.Deliveries:
      break;

    case NOTIFICATION_CATEGORY.LabelReports:
      path = `/label-reports`;
      break;

    case NOTIFICATION_CATEGORY.Artists:
      path = `/artist/${id}/external`;
      break;

    case NOTIFICATION_CATEGORY.Tracks:
      path = `/track/${id}/file`;
      break;

    case NOTIFICATION_CATEGORY.Errors:
      break;

    case NOTIFICATION_CATEGORY.SmartLinks:
      break;

    case NOTIFICATION_CATEGORY.Configurations:
      break;

    case NOTIFICATION_CATEGORY.MusicProductDigital:
      path = `/music-product-digital/${id}`;
      break;

    case NOTIFICATION_CATEGORY.SalesChannel:
      path = `/settings/sales-channel/${id}`;
      break;

    case NOTIFICATION_CATEGORY.Contract:
      path = `/label/${id}`;
      break;

    case NOTIFICATION_CATEGORY.Channel:
      path = `/channel/${id}`;
      break;

    case NOTIFICATION_CATEGORY.Video:
      break;

    case NOTIFICATION_CATEGORY.Merch:
      path = `/merch/${id}`;
      break;

    case NOTIFICATION_CATEGORY.Provider:
      path = `settings/provider/${id}`;
      break;

    case NOTIFICATION_CATEGORY.MusicProductPhysical:
      path = `/music-product-physical/${id}`;
      break;

    case NOTIFICATION_CATEGORY.Default:
      break;

    default:
      path = "/";
      break;
  }
  return path;
};
